export enum DeliveryMethod {
  APP_NOTIFICATION = 1,
}

export enum PostingTime {
  NOW = 1,
  LATER = 2,
  SCHEDULED = 3,
}

export enum SCHEDULED_TYPE {
  CHOICE_NOW = 'choice_now',
  CHOICE_LATER = 'choice_later',
  CHOICE_REPEATED = 'choice_repeated',
}
